import { reactive } from "vue";
import amendmentNotification from "@/sounds/notification-01.m4a";
import candidacyNotification from "@/sounds/notification-01.m4a";
import commentNotification from "@/sounds/notification-01.m4a";
import type { SoundEffects, SoundPlayerData } from "@/types";

export class SoundEffectPlayer {
  data: SoundPlayerData
  soundEffects: SoundEffects

  constructor({cooldown = 1000, volume = 1.0}) {
    this.data = reactive({
      cooldown: cooldown,
      canPlay: true,
      volume: volume,
    });
    this.soundEffects = {
      amendmentNotification: new Audio(amendmentNotification),
      candidacyNotification: new Audio(candidacyNotification),
      commentNotification: new Audio(commentNotification),
    }
  }

  playAmendmentNotification() {
    this.play(this.soundEffects.amendmentNotification);
  }

  playCandidacyNotification() {
    this.play(this.soundEffects.candidacyNotification);
  }

  playCommentNotification() {
    this.play(this.soundEffects.commentNotification);
  }

  play(sfx: any) {
    if (this.data.canPlay) {
      this.data.canPlay = false;
      setTimeout((that) => {
        that.data.canPlay = true;
      }, this.data.cooldown, this);
      sfx.volume = this.data.volume;
      sfx.play();
    }
  }
}